const text = (value) => String(value ?? '').trim();

const styleKey = (value) => text(value).replace(/\s+/g, '').toLowerCase();

export const combinedChildKeyOf = (child = {}) => {
  const id = text(
    child.commodityId ||
    child.commodity_id ||
    child.id ||
    child.commodity?.id
  );
  const style = text(child.style || child.keyword);
  const subStyle = text(child.subStyle || child.sub_style || child.subKeyword || child.sub_keyword);
  return id ? `child:${id}:${encodeURIComponent(styleKey(style))}:${encodeURIComponent(styleKey(subStyle))}` : '';
};

export const normalizeCombinedChildren = (product = {}) => {
  const candidates = [
    product.subCommodities,
    product.sub_commodities,
    product.combinedProducts,
    product.combined_products,
    product.combinedItems,
    product.combined_items,
  ];
  const rawChildren = candidates.find(Array.isArray) || [];
  const byKey = new Map();

  rawChildren.forEach((raw = {}) => {
    const nested = raw.commodity || raw.sub_commodity || raw.product || raw.child_commodity || {};
    const commodity = nested && typeof nested === 'object' ? nested : {};
    const commodityId = text(
      commodity.id ||
      commodity.commodity_id ||
      (typeof nested !== 'object' ? nested : '') ||
      raw.commodityId ||
      raw.commodity_id ||
      raw.productId ||
      raw.product_id ||
      raw.id
    );
    if (!commodityId) return;
    const style = text(raw.style || raw.keyword || commodity.style || commodity.keyword);
    const subStyle = text(
      raw.subStyle || raw.sub_style || raw.subKeyword || raw.sub_keyword ||
      commodity.subStyle || commodity.sub_style || commodity.subKeyword || commodity.sub_keyword
    );
    const child = {
      key: text(raw.key || raw.formChildKey) || combinedChildKeyOf({ commodityId, style, subStyle }),
      commodityId,
      id: commodityId,
      partNumber: text(commodity.partNumber || commodity.part_number || raw.partNumber || raw.part_number),
      name: text(commodity.name || raw.name) || `子商品 ${commodityId}`,
      image: commodity.image || commodity.photo || raw.image || raw.photo || '',
      style,
      subStyle,
      quantity: Math.max(1, Math.floor(Number(raw.quantity || raw.qty || raw.count || 1) || 1)),
      formResponsePolicy: raw.formResponsePolicy || commodity.formResponsePolicy || null,
    };
    const existing = byKey.get(child.key);
    byKey.set(child.key, existing
      ? { ...existing, quantity: existing.quantity + child.quantity }
      : child);
  });

  return [...byKey.values()];
};

export const isCombinedProduct = (product = {}) => (
  product.combined === true ||
  product.isCombined === true ||
  normalizeCombinedChildren(product).length > 0
);

export const normalizeCombinedFormSettings = (product = {}) => {
  const subCommodities = normalizeCombinedChildren(product);
  const combined = isCombinedProduct({ ...product, subCommodities });
  const formProductMode = product.formProductMode === 'children' ? 'children' : 'combined';
  const availableKeys = new Set(subCommodities.map((child) => child.key));
  const requestedKeys = Array.isArray(product.selectedFormChildKeys)
    ? product.selectedFormChildKeys.map(text).filter(Boolean)
    : [];
  const selectedFormChildKeys = requestedKeys.length > 0
    ? requestedKeys.filter((key) => availableKeys.has(key))
    : subCommodities.map((child) => child.key);
  const rawChildPolicies = product.formChildResponsePolicies && typeof product.formChildResponsePolicies === 'object'
    ? product.formChildResponsePolicies
    : {};
  const formChildResponsePolicies = Object.fromEntries(
    Object.entries(rawChildPolicies).filter(([key]) => availableKeys.has(key)),
  );

  return {
    combined,
    subCommodities,
    formProductMode: combined ? formProductMode : 'combined',
    selectedFormChildKeys: combined ? selectedFormChildKeys : [],
    formChildResponsePolicies: combined ? formChildResponsePolicies : {},
  };
};
